import axios from "../utils/axios";

function request(functionId, body) {
  let data = {
    functionId,
    body,
  };
  return axios.request({
    data: data,
    method: "post",
  });
}

// 圈子列表查询
export function jdh_qz_man_page(body) {
  return request("jdh_qz_man_page", body);
}

// 圈子详情查询
export function jdh_qz_man_detail(body) {
  return request("jdh_qz_man_detail", body);
}

// 圈子新增
export function jdh_qz_man_add(body) {
  return request("jdh_qz_man_add", body);
}

// 帖子列表查询
export function jdh_qz_man_post_page(body) {
  return request("jdh_qz_man_post_page", body);
}

// 帖子置顶
export function jdh_qz_man_post_top(body) {
  return request("jdh_qz_man_post_top", body);
}

// 帖子审核
export function jdh_qz_man_post_batch_audit(body) {
  return request("jdh_qz_man_post_batch_audit", body);
}
// 圈子编辑
export function jdh_qz_man_update(body) {
  return request("jdh_qz_man_update", body);
}

// 圈子分类
export function jdh_qz_man_queryCategorys(body) {
  return request("jdh_qz_man_queryCategorys", body);
}

// 分发列表查询
export function queryDistributionList(body) {
  return request("health_cmp_biz_pageDistributionContent", body);
}

// 业务内容列表查询
export function queryBusinessContentList(body) {
  return request("health_cmp_biz_pageOwnAndDistribute", body);
}

// 审核列表查询
export function queryToExamineList(body) {
  return request("health_cmp_biz_pageContentArticle", body);
}

// 单条添加频道接口（覆盖）
export function addChannel(body) {
  return request("health_cmp_biz_updateContentChannel", body);
}

// 批量添加频道（只追加）
export function batchAddChannel(body) {
  return request("health_cmp_biz_batchAppendContentChannel", body);
}

// 查询分发频道楼层
export function queryChannelFloor(body) {
  return request("health_cmp_biz_pageContentChannel", body);
}

// 生成线上文章地址
export function generateOnlineDi(body) {
  return request("health_cmp_biz_generateContentOnlineLink", body);
}

// 获取内容基础信息楼层
export function basicInformationFloor(body) {
  return request("health_cmp_biz_getContentBaseDataFloor", body);
}

// 通过父属性Id查询子属性列表
export function queryChildAttributeByPid(body) {
  return request("health_cmp_biz_queryChildAttributeByPid", body);
}

// export function queryChildAttributeByPid(body) {
//   return request("health_cmp_biz_queryParentAttributeByTyp", body);
// }

// 通过属性类型获取所有父属性
export function queryParentAttributeByTyp(body) {
  return request("health_cmp_biz_queryParentAttributeByTyp", body);
}

// 多选业务查栏目
export function pageCategoriesByBusinessIds(body) {
  return request("health_cmp_pageCategoriesByBusinessIds", body);
}

// 多选栏目查频道
export function pageChannelsByCategoryIds(body) {
  return request("health_cmp_pageChannelsByCategoryIds", body);
}

// 分发文章详情
export function getArticleByPid(body) {
  return request("health_cmp_business_getArticleById", body);
}

// 分发查询活动列表
export function pageQueryActivity(body) {
  return request("cms_marketing_man_pageQueryActivity", body);
}

// 分发查询页面模版
export function queryPageTemplate(body) {
  return request("cms_marketing_man_queryPageTemplate", body);
}
// 添加活动
export function addActivity(body) {
  return request("cms_marketing_man_addActivity", body);
}
// 绑定活动
export function batchBindingContent(body) {
  return request("cms_marketing_man_batchBindingContent", body);
}

// 查询内容质量客观主观和总质量    typeList:  [30] 图文  [31] 视频  [29] 总质量
export function queryDictionaries(body) {
  return request("health_cmp_queryDictionaries", body);
}

// 健康app 人工干预
/**
 * 请求置顶。
 * @param {Object} body - 请求体，包含要置顶的请求 ID。
 * @returns {Promise} - 包含置顶结果的 Promise 对象。
 */
export function jdh_qz_man_add_post_top(body) {
  return request("jdh_qz_man_add_post_top", body);
}
/**
 * 请求加精
 * @param {Object} body - 请求体
 * @returns {Promise} - 包含添加结果的Promise对象
 */
export function jdh_qz_man_add_post_featured(body) {
  return request("jdh_qz_man_add_post_featured", body);
}
/**
 * 取消置顶
 * @param {Object} body 请求体
 * @returns {Promise} 请求结果
 */
export function jdh_qz_man_cancel_post_top(body) {
  return request("jdh_qz_man_cancel_post_top", body);
}
/**
 * 取消加精
 * @param {Object} body 请求体
 * @returns {Promise} 请求结果
 */
export function jdh_qz_man_cancel_post_featured(body) {
  return request("jdh_qz_man_cancel_post_featured", body);
}

/**
 * 查询置顶帖子列表
 * @param {Object} body - 请求体
 * @returns {Promise} - 包含查询结果的Promise对象
 */
export function jdh_qz_man_query_post_top(body) {
  return request("jdh_qz_man_query_post_top", body);
}

/**
 * 更新帖子置顶权重
 * @param {Object} body - 请求体
 * @returns {Promise} - 包含更新结果的 Promise 对象
 */
export function jdh_qz_man_update_post_top_score(body) {
  return request("jdh_qz_man_update_post_top_score", body);
}

/**
 * 查询加精帖子列表
 * @param {Object} body - 请求体
 * @returns {Promise} - 包含查询结果的Promise对象
 */
export function jdh_qz_man_query_post_featured(body) {
  return request("jdh_qz_man_query_post_featured", body);
}

/**
 * 更新帖子加精排序
 * @param {Object} body - 请求体
 * @returns {Promise} - 包含更新结果的 Promise 对象
 */
export function jdh_qz_man_update_post_featured_score(body) {
  return request("jdh_qz_man_update_post_featured_score", body);
}

// 帖子打标列表查询
export function jdh_qz_man_post_page_label(body) {
  return request("jdh_qz_man_post_page_label", body);
}

// 帖子打标设置标签
export function jdh_qz_man_post_label_setting(body) {
  return request("jdh_qz_man_post_label_setting", body);
}

// 帖子标签查询
export function jdh_qz_man_post_label_page(body) {
  return request("jdh_qz_man_post_label_page", body);
}

export function jdh_qz_man_activity_add_post_relation(body) {
  return request('jdh_qz_man_activity_add_post_relation', body);
}

export function jdh_qz_man_activity_update_post_relation(body) {
  return request('jdh_qz_man_activity_update_post_relation', body);
}

export function jdh_qz_man_activity_bu_post_relation(body) {
  return request('jdh_qz_man_activity_bu_post_relation', body);
}

export function jdh_qz_man_activity_page_posts(body) {
  return request('jdh_qz_man_activity_page_posts', body);
}

// 圈子修改分级
export function jdh_qz_man_post_batch_update_level(body) {
  return request('jdh_qz_man_post_batch_update_level', body);
}

// 小挂件-帖子分页查询
export function jdh_qz_man_widget_post_page(body) {
  return request('jdh_qz_man_widget_post_page', body);
}

// 小挂件-帖子分页修改
export function jdh_qz_man_widget_post_update(body) {
  return request('jdh_qz_man_widget_post_update', body);
}
